import { render } from "./Anwerbung.vue?vue&type=template&id=06caccd7"
import script from "./Anwerbung.vue?vue&type=script&lang=js"
export * from "./Anwerbung.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__